var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"switch is-success",class:{'checked': _vm.value},on:{"click":function($event){$event.preventDefault();return _vm.onClicked.apply(null, arguments)}}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d3844f8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/publish-switch/publish-switch.vue
// module id = 523
// module chunks = 2